<app-dialog
  [title]="'reports.clientReport.title' | translate"
  [confirmation]="'reports.clientReport.button' | translate"
  (save)="onSubmit()"
>
  <div id="client-report-dialog">
    <div mat-dialog-content id="client-report">
      <p>{{ 'reports.clientReport.description' | translate }}</p>
      <ng-container *ngIf="!isLoadingData; else loader">
        <form [formGroup]="formGroup">
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-select formControlName="range" value="currentMonth">
                <mat-option value="currentMonth"
                            [innerHTML]="'reports.clientReport.currentMonth' | translate"></mat-option>
                <mat-option value="lastMonth" [innerHTML]="'reports.clientReport.lastMonth' | translate"></mat-option>
                <mat-option value="last3Months"
                            [innerHTML]="'reports.clientReport.last3Months' | translate"></mat-option>
                <mat-option value="static" [innerHTML]="'reports.clientReport.static' | translate"></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-container *ngIf="formGroup.value.range === 'static'">
            <div class="row date-row">
              <div class="col-6">
                <mat-label class="d-flex">
                  <label>{{ 'reports.clientReport.startDate' | translate }}</label>
                </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="date" formControlName="startDate"/>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-label class="d-flex">
                  <label>{{ 'reports.clientReport.endDate' | translate }}</label>
                </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="date" formControlName="endDate"/>
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </form>
      </ng-container>

      <ng-template #loader>
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '50px' }"></ngx-skeleton-loader>
      </ng-template>
    </div>
  </div>
</app-dialog>

